/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ServiceJourney,
} from '../models/index';
import {
    ServiceJourneyFromJSON,
} from '../models/index';

/**
 *
 */
export class RecruitmentJourneyApi extends runtime.BaseAPI {

    /**
     * Get Recruitment Journey
     */
    async getRecruitmentJourneyApiRecruitmentJourneyGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceJourney>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration?.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/recruitment-journey`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceJourneyFromJSON(jsonValue));
    }

    /**
     * Get Recruitment Journey
     */
    async getRecruitmentJourneyApiRecruitmentJourneyGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceJourney> {
        const response = await this.getRecruitmentJourneyApiRecruitmentJourneyGetRaw(initOverrides);
        return await response.value();
    }

}
